// api
import axioApi, { setHeader } from 'api/root.api';

export const smallPicUpload = async (body, token, projectId, modelId, handleUploadBar)=>{
    const urlEnd = `/editor/project/v1/${projectId}/${modelId}/icon`;
    // console.log(body);
    // setHeader('Access-Control-Allow-Origin', '*');
    setHeader('Authorization', `Bearer ${token}`);
    setHeader('Content-Type', 'multipart/form-data');
    // setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.post(urlEnd, body, {
        onUploadProgress: progressEvent => {
            handleUploadBar(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        },
    });
    const result = response.data;
    return result;
};